import type { GetClassStudentAnswersQuery } from '../../present/activity-answers.graphql.generated';
import { Field } from './response.constants';
import { useActivityAnswerId } from 'approot/activity-builder/present/activity-answers.hooks';
import ResponseField from './response-field';
import { ACTIVITIES_ANSWER_TEXT } from 'global/constants';
import { AnswerInput } from '../shared/batch-answers.context';
import type { Pluck } from 'lib/gql/pluck';

type Props = {
  answer:
    | null
    | Pluck<GetClassStudentAnswersQuery, 'getClassStudentsAnswers'>
    | undefined;
  field: Field;
  baseHeight: number;
  activityId: string;
  componentId: string;
  ariaLabelledBy?: string;
  ariaDescribedby?: string;
  onFocus?: () => void;
  updateAnswer: (input: AnswerInput) => void;
};

const ResponseViewField = ({
  answer,
  field,
  baseHeight,
  activityId,
  componentId,
  ariaLabelledBy,
  ariaDescribedby,
  onFocus,
  updateAnswer,
}: Props) => {
  const id = useActivityAnswerId(answer);

  return (
    <ResponseField
      field={field}
      answer={answer}
      baseHeight={baseHeight}
      onFocus={onFocus}
      onChange={json =>
        updateAnswer({
          __typename: 'ActivityAnswer',
          uuid: id,
          activityId,
          componentId,
          answerType: ACTIVITIES_ANSWER_TEXT,
          createdAt: new Date(),
          updatedAt: null,
          studentId: null,
          answer: {
            __typename: 'RichtextAnswer',
            answerType: ACTIVITIES_ANSWER_TEXT,
            richtext: json,
          },
          answerReferences: {
            __typename: 'ReferenceProperties',
            id: field.itemId,
            row: null,
            col: null,
          },
        })
      }
      ariaDescribedby={ariaDescribedby}
      ariaLabelledBy={ariaLabelledBy}
    />
  );
};

export default ResponseViewField;
